<template>
	<div class="Item">
		<headerItem msg="银行列表" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
		<div class="grid-container">
			<dv-scroll-board class="f-10" :config="config" :waitTime="2000000" style="width: 100%; height: 400px;" />
		</div>
	</div>
</template>
<script>
import headerItem from '../components/headerItem.vue';
export default {
	name: '',
	components: {
		headerItem
	},
	props: {
		current: Number,
	},
	watch: {
		current(newVal, oldVal) {
			if (newVal === 1) {
				this.config = this.config1
			} else if (newVal === 0) {
				this.config = this.config0
			}
		}
	},
	data() {
		return {
			config: {},
			config0: {
				header: ['银行名称', '申请数量', '总授信金额'],
				headerBGC: 'transparent',
				data: [
					['渭南分行高新支行', "190", '14830000'],
					['渭南分行韩城市支行', "349", '27900000'],
					['渭南分行西三路支行', "131", '10260000'],
					['渭南分行蒲城县支行', "597", '52390000'],
					['渭南分行经开区科技支行', "57", '4580000'],
					['渭南分行白水县支行', "382", '39184000'],
					['渭南分行澄城县支行', "397", '40440000'],
					['渭南分行富平县支行', "562", '47544000'],
					['渭南分行大荔县支行', "621", '43925000'],
					['渭南分行合阳县支行', "396", '30289476'],
					['渭南分行华阴市支行', "452", '42630000'],
					['渭南分行华州区支行', "138", '9300000'],
					['渭南分行前进支行', "76", '5435000'],
					['渭南分行临渭区支行', "152", '9880000'],
				],
				oddRowBGC: 'transparent',
				evenRowBGC: 'rgba(13, 15, 20, 1)',
				index: true,
				// columnWidth: [50],
				align: ['center']
			},
			config1: {
				header: ['银行名称', '申请数量', '总授信金额'],
				headerBGC: 'transparent',
				data: [
					['富民小微支行' ,'74' , '4510000'],
					['铜川支行' ,'357' , '30340000'],
					['鄂托克旗支行' ,'1579' , '139049317'],
					['乌兰镇支行' ,'544' , '50927956'],
					['银鑫支行' ,'93' , '5140000'],
					['银河支行' ,'157' , '9640000'],
					['达拉特旗支行' ,'586' , '39390000'],
					['银湾支行' ,'497' , '55481000'],
					['沙圪堵支行' ,'803' , '69400000'],
					['杭锦旗支行' ,'663' , '21140000'],
					['呼和浩特金鼎支行' ,'127' , '7100000'],
					['呼和浩特金辉支行' ,'208' , '13970000'],
					['呼和浩特中山西路支行' ,'128' , '8550000'],
					['包头高新支行' ,'268' , '17580000'],
					['包头青山支行' ,'459' , '33160000'],
					['包头白云路支行' ,'201' , '20210000'],
					['包头昆区支行' ,'318' , '19480000'],
					['包头昆仑支行' ,'358' , '28062000'],
					['包头土右支行' ,'439' , '35260000'],
				],
				oddRowBGC: 'rgba(13, 15, 20, 1)',
				evenRowBGC: 'transparent',
				index: true,
				// columnWidth: [50],
				align: ['center']
			}
		}
	},
	mounted() {
		this.config = this.config0
	},
	methods: {
	}
}
</script>
<style lang="less" scoped>
.Item {
	font-size: 10px !important;

	.grid-container {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr;
		/* 这表示列的大小为1fr */
		grid-template-rows: 1fr;
		/* 这表示行的大小为1fr */
		justify-items: center;

		.grid-item {
			box-sizing: border-box;
			border: 1px solid #e4e4e4;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			text-align: center;
			padding: 20px;
		}

		.custom-font /deep/ .board-item {
			font-size: 10px;
		}
	}
}
</style>
